import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, map, startWith, mapTo, distinctUntilChanged } from 'rxjs/operators';

import { GetNext, ENextActions, GetNextSuccess } from '../actions/next.actions';
import { INext } from 'src/app/models/next.interface';
import { MenuService } from 'src/app/service/http/menu/menu.service';
import { of, interval } from 'rxjs';

@Injectable()
export class NextEffects {
  
  getNext$ = createEffect(() => this._actions$.pipe(
    ofType<GetNext>(ENextActions.GetNext),
    switchMap((action) => interval(30000).pipe(startWith(0), mapTo(action))),
    switchMap(() => this._menuService.getNext()),
    distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
    switchMap((next: INext) => {
      return of(new GetNextSuccess(next));
    })
  ));

  constructor(private _menuService: MenuService, private _actions$: Actions) {}
}
